export class DownloadError extends Error {
  constructor() {
    super('Unable to download the file. Please refresh and try again.');
  }
}
